import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from 'components/Modals/ModalWrapper';
import SupportingDocuments from 'components/SupportingDocuments';

class SupportingDocumentsModal extends Component {
  static propTypes = {
    id: PropTypes.string,
    supportingDocs: PropTypes.arrayOf(PropTypes.shape({})),
    onCancel: PropTypes.func.isRequired
  };

  static defaultProps = {
    id: null,
    supportingDocs: null
  };

  onCancel() {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  render() {
    const { id, supportingDocs } = this.props;

    const title = <h1>Supporting Documents</h1>;
    const content = <SupportingDocuments
      formId={ !Number.isNaN(id) ? parseInt(id, 10) : null }
      documents={ supportingDocs }
    />;

    return (
      <ModalWrapper
        title={ title }
        className="modal-supportingdocuments"
        content={ content }
        showCancel={ false }
        showConfirm={ false }
        showFooter={ false }
        onCancel={ () => this.onCancel() }
      />);
  }
}

function mapStateToProps(state) {
  const {
    form: {
      formData,
      isSigningForm
    }
  } = state;

  return {
    formData,
    isSigningForm
  };
}

export default connect(
  mapStateToProps
)(SupportingDocumentsModal);
